module.exports = __webpack_public_path__ + "img/16.a97df238.jpg";